<div class="pages-body login-page flex flex-column">
    <div class="align-self-center mt-auto mb-auto">
        <div class="pages-panel card flex flex-column" 
             [@shakeAnimation]="shakeState" 
             [@zoomOutAnimation]="zoomState">
            <div class="pages-header px-3 py-1">
                <h2>ANMELDUNG</h2>
            </div>

            <h4>{{ applicationServiceExt.headerCaption }}</h4>

            <div class="pages-detail mb-6 px-6">
                Bitte mit Benutzernamen und Kennwort anmelden.
            </div>

            <!-- Login Error Message -->
            <div *ngIf="loginErrorMessage" class="px-6 mb-3">
                <small class="p-error">{{ loginErrorMessage }}</small>
            </div>

            <form class="login-form" (ngSubmit)="loginAsync()">
            <div class="input-panel flex flex-column px-3">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                        <i class="fa fa-house-user"></i>
                    </span>
                    <span class="p-float-label">
                        <input
                            #mandatorInput
                            type="text"
                            id="mandator"
                            name="mandator"
                            autocomplete="organization"
                            required
                            [(ngModel)]="mandator"
                            pInputText
                            [ngClass]="{'ng-invalid ng-dirty': isMandatorInvalid}"
                        />
                        <label for="mandator">Mandant</label>
                    </span>
                </div>
                <small *ngIf="isMandatorInvalid" class="p-error ml-3">{{ mandatorValidationMessage }}</small>
                <div class="p-inputgroup mt-3">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-user"></i>
                    </span>
                    <span class="p-float-label">
                        <input
                            #usernameInput
                            type="text"
                            id="username"
                            name="username"
                            autocomplete="username"
                            required
                            [(ngModel)]="userName"
                            pInputText
                            [ngClass]="{'ng-invalid ng-dirty': isUserNameInvalid}"
                        />
                        <label for="username">Benutzername</label>
                    </span>
                </div>
                <small *ngIf="isUserNameInvalid" class="p-error ml-3">Benutzername ist erforderlich</small>
                <div class="p-inputgroup mt-3 mb-3">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-lock"></i>
                    </span>
                    <span class="p-float-label">
                        <input
                            [type]="showPassword ? 'text' : 'password'"
                            id="password"
                            name="password"
                            autocomplete="current-password"
                            required
                            [(ngModel)]="password"
                            pInputText
                            [ngClass]="{'ng-invalid ng-dirty': isPasswordInvalid}"
                        />
                        <label for="password">Password</label>
                    </span>
                    <span class="p-inputgroup-addon" style="cursor: pointer;" (click)="togglePasswordVisibility()">
                        <i [class]="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
                    </span>
                </div>
                <small *ngIf="isPasswordInvalid" class="p-error ml-3 mb-3">Passwort ist erforderlich</small>
            </div>

            <!-- Deliberately always enabled: submitting with empty fields is what
                 reveals the "field is required" messages. loginAsync() sets them and
                 then bails out on canLogin, so nothing is sent to the server. -->
            <p-button
                type="submit"
                class="login-button mb-6 px-3"
                label="LOGIN"
            ></p-button>
            </form>
        </div>
    </div>
</div>
<ngx-loading
    [show]="showBusyScreen || (isBusy$ | async)"
    [config]="{ backdropBorderRadius: '3px', fullScreenBackdrop: true }"
></ngx-loading>
